<template lang="html">
  <div class="main">
    <div class="main-box-a" :class="appActive">
      <div class="ball cell" @click="newFile">
        <div class="word" style="right: 70px;top:16px">
          {{message.Al126}}
        </div>
        <i class="material-icons">send</i>
        <!-- <img src="../../assets/images/icon-add.png" alt=""> -->
      </div>
      <div v-show="show">
        <div class="cell add-user" v-if="account.role !== 2" @click="AddEmail()">
          <div class="word">
            {{message.Sl137}}
          </div>
          <i class="material-icons">person_add</i>
          <comp-email :toAddEmail="toAddEmail" ref="addEmail"></comp-email>
        </div>
        <div class="open cell" @click="open">
          <div class="word">
            {{message.Sl198}}
          </div>
          <i class="material-icons">folder_open</i>
        </div>
        <div class="suggest cell" @click="sendMsg">
          <div class="word">
            {{message.Sl223}}
          </div>
          <i class="material-icons">sms</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CompEmail from '@/components/addEmail.vue'
export default {
  computed: {
    ...mapGetters({
      app: 'app',
      notice: 'notice',
      account: 'account',
      el: 'el',
      space: 'space'
    }),
    spaceNew () {
      return JSON.parse(JSON.stringify(this.space))
    }
  },
  components: {
    CompEmail,
  },
  watch: {
    'app.login': function (val) {
      if (val) {
        this.appActive = 'active'
      } else {
        this.appActive = ''
      }
    },
    spaceNew: {
      handler: function (val, oldVal) {
        if (val.id !== oldVal.id) {
          this.space.id = val.id
          this.getRole()
        }
      }
    }
  },
  data () {
    return {
      message: {
        submit: this.$lang.ui.form.submit,
        Al117: this.$lang.ui.app.l117,
        Al126: this.$lang.ui.app.l126,
        Sl137: this.$lang.ui.system.l137,
        Sl198: this.$lang.ui.system.l198,
        Sl223: this.$lang.ui.system.l223
      },
      show: true,
      appActive: '',
      userRole: 0,
      showEmail: false,
      toAddEmail: false
    }
  },
  mounted () {
    if (this.app.login) {
      this.appActive = 'active'
    } else {
      this.appActive = ''
    }
    // this.$api.getUserRole(this.space.id, response => {
    //   this.userRole = response.permission.operation
    // })
    this.getRole()
  },
  methods: {
    getRole () {
      this.$api.getUserRole(this.space.id, response => {
        this.userRole = response.permission.operation
      })
    },
    newFile: function () {
      if (this.userRole !== 2) {
        this.$store.dispatch('alertWarn', false)
        if (this.app.login) {
          var aa = !this.el.newFile
          this.$store.dispatch('newFile', aa)
          this.$store.dispatch('maxFile', '')
        } else {
          this.$app.login(0, response => {
            if (response === 2) {
              this.$app.start()
            }
          })
        }
      } else {
        this.$message({
          message: this.$lang.ui.prompt.l150.l0 + localStorage.getItem('projectName') + this.$lang.ui.prompt.l150.l1,
          type: 'error'
        })
      }
    },
    open () {
      this.$store.dispatch('alertWarn', false)
      if (this.app.login) {
        this.$app.openFloder()
      } else {
        if (!this.app.login) {
          this.$app.login(0, response => {
            if (response === 2) {
              this.$app.start()
            }
          })
        }
      }
    },
    AddEmail () {
      this.toAddEmail = true
      this.$refs.addEmail.showBox()
    },
    mouseOver: function () {
      this.show = !this.show
    },
    sendMsg () {
      this.$store.dispatch('showMsg', true)
    }
  }
}
</script>

<style lang="css" scoped>
.main {
  z-index: 999;
  width: 56px;
  height: 300px;
  position: fixed;
  bottom: 45px;
  right: 25px;
  background-color: transparent;
}
.main-box-a {
  width: 100%;
  height: 100%;
}
/*.main-box-a:hover .word {
  display: block;
}*/
.main-box-a:hover .add-user {
  opacity: 1;
  display: block;
}
.main-box-a:hover .add-transfer,
.main-box-a:hover .open,
.main-box-a:hover .suggest {
  opacity: 0.6;
}
.main-box-a.active:hover .add-transfer,
.main-box-a.active:hover .open,
.main-box-a:hover .suggest {
  opacity: 1;
}
.main-box-a.active .ball {
  opacity: 1;
}
.main-box-a .ball i {
  opacity: 1;
  transition: opacity 1.2s;
  position: absolute;
  font-size: 24px;
  top: 16px;
  left: 18px;
}
/* .main-box-a:hover .ball img {
  transform:rotate(180deg);
  transition: transform 0.6s, opacity 0.6s;
  opacity: 0;
} */
.main-box-a:hover .ball i {
  opacity: 1;
}
.main-box-a:hover {
  height: 180px;
}
.cell:hover .word {
  display: block;
}
.ball {
  opacity: 0.6;
  position: absolute;
  bottom: 0;
  cursor: pointer;
  width: 56px;
  height: 56px;
  font-size: 18px;
  color: #fff;
  border-radius: 58px;
  box-shadow: 0 0 4px rgba(0,0,0,.1), 0 4px 8px rgba(0,0,0,.2);
  /*background-color: #d9534f;*/
  background-color: #f37e21;
}
.ball img {
  float: left;
  margin-top: 16px;
  margin-left: 16px;
}
.add-transfer,
.open,
.suggest {
  opacity: 1;
  /* transition: opacity 0.5s ease; */
  position: absolute;
  /*transition: width 1s ease, height 1s ease;*/
  cursor: pointer;
  bottom: 70px;
  left: 4px;
  width: 46px;
  height: 46px;
  border-radius: 46px;
  text-align: center;
  color: #fff;
  background-color: #007bc5;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
}
.open {
  bottom: 70px;
  opacity: 1;
}
.suggest {
  bottom: 130px;
}
.add-transfer i {
  font-size: 30px;
  margin-top: 8px;
}
.open i {
  font-size: 24px;
  margin-top: 12px;
}
.suggest i {
  font-size: 24px;
  margin-top: 12px;
}
.add-user {
  opacity: 1;
  /* transition: opacity 0.5s ease; */
  position: absolute;
  /*transition: width 1s ease, height 1s ease;*/
  cursor: pointer;
  bottom: 190px;
  left: 4px;
  width: 46px;
  height: 46px;
  line-height: 46px;
  text-align: left;
  font-size: 18px;
  border-radius: 46px;
  text-align: center;
  color: #fff;
  background-color: #007bc5;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
}
.add-user i {
  margin-top: 10px;
}
.word {
  display: none;
  position: absolute;
  font-size: 14px;
  padding: 0 10px;
  width: auto;
  background-color: rgba(0, 0, 0, 0.65);
  white-space:nowrap;
  color: #fff;
  right: 60px;
  top: 10px;
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
}
.phone {
  width: 100%;
  margin-top: 10px;
  height: 24px;
  text-align: left;
  line-height: 24px;
  font-size: 14px;
  color: #878d99;
  padding-left: 4px;
}
.phone i {
  float: left;
  font-size: 24px;
  margin-right: 4px;
}
</style>
